import { Box, Button, Table, Text } from '@factorialco/deprecated-design-system'
import { QuotePricingLineItemFragment } from 'generated/resources/graphql'

import MoneyField from 'modules/core/components/MoneyField'
import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface ItemRowProductProps {
  item: QuotePricingLineItemFragment
  currency: string
  onUpdate: (updates: Partial<QuotePricingLineItemFragment>) => void
  onDelete: () => void
}

const ItemRow = ({ item, currency, onUpdate, onDelete }: ItemRowProductProps) => {
  const {
    access: { locale },
  } = useCurrentSession()

  return (
    <Table.Row>
      <Table.Cell colSpan={2}>
        <Box paddingLeft="s24" width="s300">
          <TextField
            placeholder={i18n.t('common.name')}
            value={item.description || ''}
            onChange={(value) => onUpdate({ ['description']: value })}
          />
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box width="s96">
          <MoneyField
            placeholder="0"
            currency={item.type === 'role' ? 'hr' : 'u'} // TODO: Translate
            onChange={(value) => onUpdate({ ['quantity']: Number(value) })}
            value={(item.quantity || 0).toString()}
          />
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: item.unitPriceCents || 0,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>

      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {`${(item.taxRatePercentage || 0 * 100).toFixed(2)}%`}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: item.totalPriceCents || 0,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={1} width={80}>
        <Button type="secondary" iconName="delete" onClick={onDelete} />
      </Table.Cell>
    </Table.Row>
  )
}

export default ItemRow
